module.exports = __webpack_public_path__ + "static/aina-ce9d326f319b7c06824d92f82c0e861b.png";